export default __webpack_public_path__ + "static/media/loading.64e06f61.gif";